import { Tabs } from '@mui/material';
import { DynamicIcon } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import { ModuleTabOptions } from '~/components/ModulePageConfigProvider/ModulePageConfigProvider.types';

import { TabStyled } from './ModulePageTabs.styled';

export interface ModulePageTabsProps {
  items: ModuleTabOptions[];
}

export const ModulePageTabs = ({ items }: ModulePageTabsProps) => {
  const { t } = useTranslation();
  const { tabId } = useParams() as { tabId?: string };
  const activeTab = tabId || items[0]?.slug;
  const path = tabId ? '../' : './';
  return (
    <Tabs value={activeTab} variant="scrollable" scrollButtons={false}>
      {items?.map((tab) => (
        <TabStyled
          key={tab.slug}
          to={`${path}${tab.slug}`}
          component={Link}
          iconPosition="start"
          icon={tab.icon && <DynamicIcon iconName={tab.icon} fontSize="small" />}
          label={t(tab.label)}
          value={tab.slug}
        />
      ))}
    </Tabs>
  );
};
